import React, { useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import useFavorite from '../../hooks/useFavorite';
import getUri, { getNonApiUri, getPageHelpUri } from '../../utils/getUri';
import { HighlightedSection, Title, Fields, SingleSelect } from 'smartsuite-ui';
import App from './App';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});

export default function AppWrapper(props) {
    // const FlightStatusToolTranslation = useTranslation('flightStatusTool');
    // const favoriteUtilities = useFavorite();

    // const pageTitles = advancedSearchTranslation.t('pageTitles', {
    //     returnObjects: true,
    // });
    // const labels = advancedSearchTranslation.t('labels', {
    //     returnObjects: true,
    // });

    return (
        <QueryClientProvider client={queryClient}>
            <App history={props.history} />
            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    );
}
